// JS
import '../../custom/js/index';

// Base SCSS
import '../../custom/scss/base.scss';

// Components SCSS
import '../../custom/scss/components/content/content-hero.scss';
import '../../custom/scss/components/content/content-detail.scss';

// Pages
import '../../custom/scss/pages/local-checkoff.scss';
